import { buttonVariants, HapticSurface } from "@pax/ui";
import { Link } from "@tanstack/react-router";

export function ApiProblem({
  title = "Unable to load this page",
  message,
}: {
  title?: string;
  message: string;
}) {
  return (
    <main className="mx-auto flex max-w-xl flex-col items-center px-6 py-20 text-center">
      <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
      <p className="mt-3 text-sm text-muted-foreground">{message}</p>
      <Link to="/" className={buttonVariants({ variant: "outline", className: "mt-6" })}>
        Browse scenarios
        <HapticSurface />
      </Link>
    </main>
  );
}
